
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/specials",
      function () {
        return require("private-next-pages/specials.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/specials"])
      });
    }
  